import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { generateQueryKey } from '../../../../utils/generate-query-key';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { updateObject } from '../../../../utils/object-utils';
import { browsingDomainStore } from '../../store';
import { assignShowtimeListRelatedData } from '../../utils/showtimes/assign-related-data';
export const loadShowtimesForFirstBusinessDate = async (query) => {
    // The 'first business date' is calculated server-side, therefore there's no reliable way to check
    // whether the data has already been loaded and use the cache instead.
    // See US239585.
    const queryKey = generateQueryKey(query);
    const response = await ocapiClient.instance.v1.browsing.masterData.showtimes.getForFirstBusinessDate(query);
    if (!response)
        return;
    const { showtimes, relatedData, businessDate } = response;
    const cacheDuration = getCacheDuration('showtimes');
    runInAction(() => {
        browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey] = {
            [businessDate]: createFetchedData(showtimes.map(showtime => showtime.id), cacheDuration)
        };
        updateObject(browsingDomainStore.data.showtimesById, createFetchedDataRecord(showtimes, 'id', cacheDuration));
        assignShowtimeListRelatedData(relatedData, cacheDuration);
    });
};
